<div
  [ngClass]="{ 'tw-hidden': !showChartOptions, 'tw-flex-col tw-relative': layoutService.isSmallScreen$ | async }"
  class="charts-actions chart-options-mobile tw-flex tw-flex-row tw-justify-between tw-mb-2 tw-flex-wrap tw-gap-y-2 tw-text-dark-light-dynamic">
  <app-option-toggle
    label="Breakdown by:"
    [options]="breakdownByToggleOptions"
    [selectedValue]="selectedBreakdownBy"
    (selectionChange)="onBreakdownByChanged($event)">
  </app-option-toggle>
  <app-option-toggle
    label="Values:"
    [options]="valueTypeOptions"
    [selectedValue]="selectedValueType"
    (selectionChange)="toggleValueType($event)">
  </app-option-toggle>
</div>
<div [style.height]="getChartContainerHeight()" class="tw-rounded tw-relative" [class.mat-card-shadow]="boxShadow">
  <div id="highchartsContainer-{{ chartId }}" class="tw-rounded"></div>
</div>
